import type { ApolloError } from '@apollo/client';
import type { ApacCandidateHeader } from '@seek/apac-candidate-header-footer';
import type { Country, Language, SiteName } from '@seek/melways-sites';
import type { ComponentProps } from 'react';

import type { Config } from './config';
import type {
  RECOMMENDED_JOBS_ROUTE_NAME,
  SAVED_SEARCH_ROUTE_NAME,
} from './constants';
import type { RecommendationsData } from './queries/types';

export type Route =
  | typeof RECOMMENDED_JOBS_ROUTE_NAME
  | typeof SAVED_SEARCH_ROUTE_NAME;

export interface ClientContext {
  site: SiteName;
  environment: string;
  route: Route;
  language: Language;
}
export const skuEnvironments = [
  'development',
  'staging',
  'production',
] as const;
export type SkuEnvironment = (typeof skuEnvironments)[number];

export const supportedCountries: Country[] = [
  'au',
  'nz',
  'hk',
  'id',
  'th',
  'ph',
  'my',
  'sg',
];

export interface SolTracker {
  trackDisplayed: (token: string) => void;
}
export enum ContainerWidth {
  Large = 'large',
  Medium = 'medium',
}

export interface HeaderFooterSharedProps {
  loading: boolean;
  error?: ApolloError;
}

type Candidate = NonNullable<RecommendationsData['viewer']>;

export type HeaderProps = Partial<
  Pick<Candidate, 'emailAddress' | 'trackingId' | 'id'>
> &
  HeaderFooterSharedProps & {
    firstName?: Candidate['personalDetails']['firstName'];
    width?: ContainerWidth;
    activeAuthedUserTab: ComponentProps<
      typeof ApacCandidateHeader
    >['activeAuthedUserTab'];
  };

export type FooterProps = HeaderFooterSharedProps & { width?: ContainerWidth };

declare global {
  interface Window {
    APP_CONFIG: Config;
    hj: any;
  }
}
